// @charset "utf-8"
import Vue from 'vue'
import quoteChartVue from '@/components/lib/quote-chart'

var QuoteChartVueConstructor = Vue.extend(quoteChartVue)

var instance = null
const instanceId = 'quotechart_id'
let curType = 'daykline'

var QuoteChart = function (options) {
    if (!('code' in options)) {
        return
    }

    if (Vue.prototype.$isServer) {
        return
    }

    options.updateCurType = function (type) {
        curType = type
    }
    if (instance) {
        options['type'] = curType
        instance.vm.show(options)
    } else {
        options['type'] = curType
        instance = new QuoteChartVueConstructor({
            data: options
        })
        instance.id = instanceId
        instance.vm = instance.$mount()
        document.body.appendChild(instance.vm.$el)
        instance.vm.visible = true
        instance.dom = instance.vm.$el
    }
    return instance.vm
}

QuoteChart.hide = function (code, userOnClose) {
    if (instance && 'vm' in instance && instance.vm.code === code) {
        instance.vm.hide()
        if (typeof userOnClose === 'function') {
            userOnClose(instance)
        }
    }
}

export default QuoteChart



// WEBPACK FOOTER //
// ./src/lib/quoteChartVue.js